import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { id, name, icon, descriptionShort, searchKeywords, helpText, docsUrl, } from "../image/SDKDocsBlockActualImage";
const b = new DocsBlockBuilder();
/**
 * 2. Block properties
 */
const properties = {
    image: b.imageProperty({
        id: "image",
        name: "Image",
        options: {
            allowCaption: true,
            imageSources: ["figmaStandalone", "upload"],
            editorInteractivity: "viewOnly",
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.image],
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.image],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.media,
    description: descriptionShort,
    item: blockItem,
    appearance: {
        isBordered: false,
    },
    searchKeywords,
    onboarding: b.onboarding({
        helpText,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as Image };
